// --------------------------------------------------------------
// Created On: 2026-04-21
// Author: Dimitra Weinstein
//
// Last Modified: 2026-05-07
// Modified By: Zachary Thomas
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

// Constants for tooltip messages.
const copilotDeviceConnected: TooltipBullet[] = [
  {
    showBulletSymbol: true,
    title: "Monitor LED",
    description: "Note the blue LED blinking pattern, normal operation is a slow “breathing” pattern on the LED.",
  },
  {
    showBulletSymbol: true,
    title: "Physical Check",
    description:
      "Inspect GPS and LTE antennas for broken wires or loose connections reseating all connections, ensuring the antennas are connected to the correct ports.",
  },
  {
    showBulletSymbol: true,
    title: "Verify Coverage",
    description: "Check LTE signal strength on a mobile device at the site.",
  },
  {
    showBulletSymbol: true,
    title: "Power Cycle",
    description:
      "If a slow or rapid double blink persists for minutes, power cycle the Co-Pilot before replacing antennas.",
  },
  {
    showBulletSymbol: true,
    title: "Escalate",
    description: "If no “heartbeat” pattern is established, escalate.",
  },
];

const copilotLatestFirmware: TooltipBullet[] = [
  {
    showBulletSymbol: false,
    title: "Firmware",
    description:
      "Check that the Co-Pilot is using the latest firmware version. If not, update to the latest firmware and check if the issue is resolved.",
  },
];

const copilotControllerConnected: TooltipBullet[] = [
  {
    showBulletSymbol: true,
    title: "Pre-Check",
    description: 'Ensure the blue LED is "breathing" and verify the controller configuration in app.',
  },
  {
    showBulletSymbol: true,
    title: "Verify Settings",
    description: "Ensure baud rate, parity, slave ID, stop bits, and firmware match the controller configuration.",
  },
  {
    showBulletSymbol: true,
    title: "Wiring Check",
    description: "Inspect connections for corrosion, broken wires, and correct pin-out.",
  },
  {
    showBulletSymbol: true,
    title: "Component Swap",
    description: "Replace the Modbus harness and primary pigtail sequentially; test after each change.",
  },
  {
    showBulletSymbol: true,
    title: "Escalate",
    description: "If the connection still fails, escalate.",
  },
];

const copilotAnalogSensorsConnected: TooltipBullet[] = [
  {
    showBulletSymbol: true,
    title: "Physical Check",
    description: "Inspect harnesses for frayed wires, damage, or broken pins.",
  },
  {
    showBulletSymbol: true,
    title: "Cross Test",
    description:
      "If one of two sensors report online in app, swap suction and discharge harnesses at the pigtail connection, then check again.",
  },
  {
    showBulletSymbol: true,
    title: "Transducer Swap",
    description:
      "Replace the sensor with a different transducer (suction and discharge sensors are interchangeable for testing).",
  },
  {
    showBulletSymbol: true,
    title: "Pigtail Swap",
    description: "Replace the primary pigtail with a known working unit.",
  },
  {
    showBulletSymbol: true,
    title: "Unit Swap",
    description: "Test with a different Co-Pilot to see if analog data populates.",
  },
];

const copilotModbusSensorsConnected: TooltipBullet[] = [
  {
    showBulletSymbol: true,
    title: "Pre-Check",
    description: 'Ensure the blue LED is "breathing" and verify the Modbus configuration in app.',
  },
  {
    showBulletSymbol: true,
    title: "Verify Settings",
    description: "Ensure baud rate, parity, slave ID, stop bits, and firmware match the Modbus configuration.",
  },
  {
    showBulletSymbol: true,
    title: "Wiring Check",
    description: "Inspect connections for corrosion, broken wires, and correct pin-out.",
  },
  {
    showBulletSymbol: true,
    title: "Component Swap",
    description: "Replace the Modbus harness and primary pigtail sequentially; test after each change.",
  },
  {
    showBulletSymbol: true,
    title: "Escalate",
    description: "If the connection still fails, escalate.",
  },
];

export const TOOLTIPS: TooltipMap = {
  COPILOT: {
    copilotDeviceConnected,
    copilotLatestFirmware,
    copilotControllerConnected,
    copilotAnalogSensorsConnected,
    copilotModbusSensorsConnected,
  },
};

interface TooltipMap {
  [key: string]: TooltipSection;
}

interface TooltipSection {
  [key: string]: TooltipBullet[];
}

interface TooltipBullet {
  showBulletSymbol: boolean;
  title: string;
  description: string;
}
